import { Injectable } from '@angular/core';
import { LoginRequest } from 'src/app/services/requests/login.request';
import { OrganizationRequest } from 'src/app/services/requests/organization.request';
import { SiteRequest } from 'src/app/services/requests/site.request';
import { DeviceRequest } from 'src/app/services/requests/device.request';
import { ServiceRequest } from 'src/app/services/requests/service.request';
import { DashboardRequest } from 'src/app/services/requests/dashboard.request';
import { ProgressRequest } from 'src/app/services/requests/progress.request';
import { TimestableRequest } from 'src/app/services/requests/timestable.request';
import { OperatorRequest } from 'src/app/services/requests/operator.request';
import { MessageRequest } from 'src/app/services/requests/message.request';
import { StatisticRequest } from 'src/app/services/requests/statistic.request';
import { PlaceRequest } from 'src/app/services/requests/place.request';
import { HubRequest } from 'src/app/services/requests/hub.request';
import { SlotRequest } from 'src/app/services/requests/slot.request';
import { MediaRequest } from 'src/app/services/requests/media.request';
import { SlotModelRequest } from 'src/app/services/requests/slot-model.request';
import { ExtraParamsRequest } from 'src/app/services/requests/extra-params.request';
import { LicenceRequest } from 'src/app/services/requests/licence.request';
import { AppRouterRequest } from 'src/app/services/requests/app-router.request';
import { BookNumberingRequest } from 'src/app/services/requests/booknumbering.request';
import { DeviceStatusRequest } from 'src/app/services/requests/device-status.request';

@Injectable({
  providedIn: 'root',
})
export class RequestManager {
  constructor(
    private _login: LoginRequest,
    private _organization: OrganizationRequest,
    private _site: SiteRequest,
    private _device: DeviceRequest,
    private _service: ServiceRequest,
    private _dashboard: DashboardRequest,
    private _progress: ProgressRequest,
    private _timestable: TimestableRequest,
    private _operator: OperatorRequest,
    private _message: MessageRequest,
    private _place: PlaceRequest,
    private _hub: HubRequest,
    private _slot: SlotRequest,
    private _statistic: StatisticRequest,
    private _slotModel: SlotModelRequest,

    private _media: MediaRequest,
    private _extraParams: ExtraParamsRequest,
    private _licence: LicenceRequest,
    private _appRouter: AppRouterRequest,
    private _bookNumbering: BookNumberingRequest,
    private _deviceStatus: DeviceStatusRequest
  ) {}

  login() {
    return this._login;
  }

  organization() {
    return this._organization;
  }

  site() {
    return this._site;
  }

  device() {
    return this._device;
  }

  service() {
    return this._service;
  }

  dashboard() {
    return this._dashboard;
  }

  progress() {
    return this._progress;
  }

  timestable() {
    return this._timestable;
  }

  operator() {
    return this._operator;
  }

  message() {
    return this._message;
  }

  place() {
    return this._place;
  }

  hub() {
    return this._hub;
  }

  slot() {
    return this._slot;
  }

  statistic() {
    return this._statistic;
  }

  media() {
    return this._media;
  }
  extraParams() {
    return this._extraParams;
  }

  licence() {
    return this._licence;
  }
  slotModel() {
    return this._slotModel;
  }

  appRouter() {
    return this._appRouter;
  }

  bookNumbering() {
    return this._bookNumbering;
  }

  deviceStatus() {
    return this._deviceStatus;
  }
}
